import type { SelectChangeEvent } from "@mui/material";
import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useId } from "react";

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const PeriodFilter = ({ value, onChange }: Props) => {
  const labelId = useId();

  const options = [
    { optionValue: 0, optionText: "All Time" },
    { optionValue: 1, optionText: "Today" },
    { optionValue: 7, optionText: "Last Week" },
  ];

  const handleChange = (e: SelectChangeEvent<number>) => onChange(+e.target.value);

  return (
    <FormControl>
      <InputLabel id={labelId}>Period</InputLabel>
      <Select<number>
        label="Period"
        labelId={labelId}
        value={value}
        onChange={handleChange}
        renderValue={(val) => (
          <Typography variant="body2">{options.find((o) => o.optionValue === val)?.optionText}</Typography>
        )}
      >
        {options.map(({ optionValue, optionText }) => (
          <MenuItem key={optionValue.toString()} value={optionValue}>
            {optionText}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PeriodFilter;
